export class BlogImage {
    public id: number;
    public name: string;
    public createdAt: string;
    public imageUrl: string;
    public path: string;

    static fromDto(b): BlogImage {
        const blogImage = new BlogImage();

        if (!b) {
            return null;
        }

        blogImage.id = b.id;
        blogImage.name = b.name;
        blogImage.createdAt = b.createdAt;
        blogImage.imageUrl = b.imageUrl;
        blogImage.path = b.path;

        return blogImage;
    }
}
